import { FieldTimeOutlined } from '@ant-design/icons'
import { GraviButton } from '@gravitate-js/excalibrr'
import { Tooltip } from 'antd'
import React from 'react'

type PriceHistoryButtonProps = {
  handleShowDrawer: () => void
}

export function PriceHistoryButton({ handleShowDrawer }: PriceHistoryButtonProps) {
  return (
    <Tooltip title='View Price History'>
      <GraviButton
        icon={<FieldTimeOutlined />}
        style={{ float: 'right', marginRight: '1em' }}
        theme2
        appearance='outline'
        onClick={handleShowDrawer}
      />
    </Tooltip>
  )
}
